import { observable } from 'mobx';
import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import locales from './locales';
import vhCheck from 'vh-check';
import getRemScale from '@src/utils/get-rem-scale';

class ThirdSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 是否激活
  @observable isActive = false;
  // 版本切换的索引
  @observable currentIndex = 0;
  // 版本亮点列表  本地化
  versionList = locales;

  @observable vhOffset;

  // @observable
  // versionList = [
  //   {
  //     title: 'PVE',
  //     info: 'AIRSHIP: CONSTANTINE',
  //     bgImgs: require('./images/img1.jpg'),
  //     tabCoverImgs: require('./images/tab-cover.png')
  //   },
  //   {
  //     title: '战利品',
  //     info: '占位',
  //     bgImgs: require('./images/img1.jpg'),
  //     tabCoverImgs: require('./images/tab-cover.png')
  //   },
  //   {
  //     title: '撤离',
  //     info: '占位',
  //     bgImgs: require('./images/img1.jpg'),
  //     tabCoverImgs: require('./images/tab-cover.png')
  //   },
  //   {
  //     title: '使命',
  //     info: '占位',
  //     bgImgs: require('./images/img1.jpg'),
  //     tabCoverImgs: require('./images/tab-cover.png')
  //   },
  //   {
  //     title: '自定义武装',
  //     info: '占位',
  //     bgImgs: require('./images/img1.jpg'),
  //     tabCoverImgs: require('./images/tab-cover.png')
  //   },
  //   {
  //     title: '超大战场',
  //     info: '占位',
  //     bgImgs: require('./images/img1.jpg'),
  //     tabCoverImgs: require('./images/tab-cover.png')
  //   }
  // ];

  versionSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 5000
      },
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    }
  });

  versionTabSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 3,
      centeredSlides: true,
      spaceBetween: 20
      // loopedSlides: 3
    }
  });

  use() {
    useMount(async () => { });
    useEffect(() => {
      try {
        const vhCheckResult = vhCheck();
        const remScale = getRemScale();
        this.vhOffset = (vhCheckResult?.offset || 0) * remScale;
      } catch (e) {
        console.error(e);
      }
    }, []);
    useEffect(
      () => {
        this.currentIndex = this.versionTabSwiper.activeIndex;
        this.versionSwiper.activeIndex = this.versionTabSwiper.activeIndex;
      },
      [this.versionTabSwiper.activeIndex]
    );
    useEffect(
      () => {
        this.versionTabSwiper.activeIndex = this.versionSwiper.activeIndex;
        this.currentIndex = this.versionSwiper.activeIndex;
      },
      [this.versionSwiper.activeIndex]
    );
    useEffect(
      () => {
        this.versionSwiper.activeIndex = this.currentIndex;
        this.versionTabSwiper.activeIndex = this.currentIndex;
      },
      [this.currentIndex]
    );
  }
}

export default ThirdSectionStore;
